import { ViewStateRecordsAlias } from '@common/services/layout-state';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AttachmentListItem } from '@src/suite/common/data-models/complex-types/attachment-list';
import { EnpsField } from '@src/suite/common/data-models/fields/enps-field';
import { ObjectTypes } from '@src/suite/common/enums/object-types';
import { UploadFile } from 'ngx-uploader';

//TODO: Add add actions for each record type
export const TopicRecordActions = createActionGroup({
    source: 'Topic Record',
    events: {
        'Set Topics': props<{ records: Map<string, StorytellingTopicRecord> }>(),
        'Set topic templates': props<{ templates: StorytellingTopicRecord[] }>(),
        'Update Topics': props<{ records: StorytellingTopicRecord[] }>(),
        'Delete Topics': props<{ records: StorytellingTopicRecord[] }>(),
    },
});

export const RundownRecordActions = createActionGroup({
    source: 'Rundown Record',
    events: {
        'Set Rundowns': props<{ records: Map<string, StorytellingRundownRecord> }>(),
        'Update Rundowns': props<{ records: StorytellingRundownRecord[] }>(),
    },
});

export const PublicationRecordActions = createActionGroup({
    source: 'Publication Record',
    events: {
        'Set Publication Channels': props<{ records: Map<string, StorytellingPublicationChannelRecord> }>(),
        'Set Publications': props<{ records: Map<string, StorytellingPublicationRecord> }>(),
        'Set Publication List': props<{ records: Map<string, StorytellingPublicationListRecord> }>(),
        'Update Publication Channels': props<{ records: StorytellingPublicationChannelRecord[] }>(),
        'Update Publications': props<{ records: StorytellingPublicationRecord[] }>(),
        'Update Publication List': props<{ records: StorytellingPublicationListRecord[] }>(),
    },
});

export const AssignmentRecordActions = createActionGroup({
    source: 'Assignment Record',
    events: {
        'Set Assignments': props<{ records: Map<string, StorytellingAssignmentRecord> }>(),
        'Update Assignments': props<{ records: StorytellingAssignmentRecord[] }>(),
        'Delete Assignments': props<{ records: StorytellingAssignmentRecord[] }>(),
    },
});

export const StoriesRecordActions = createActionGroup({
    source: 'Story Record',
    events: {
        'Set Stories': props<{ records: Map<string, StorytellingStoryRecord> }>(),
        'Update Stories': props<{ records: StorytellingStoryRecord[] }>(),
        'Set story templates': props<{ templates: StorytellingStoryRecord[] }>(),
        'Update story templates': props<{ templates: StorytellingStoryRecord[] }>(),
        'Delete Stories': props<{ records: StorytellingStoryRecord[] }>(),
        'Fix Moved Story': props<{ record: StorytellingRundownRecord }>(),
        'Set Story Has Unsaved Changes': props<{ storyGuid: string; hasUnsavedChanges: boolean }>(),
    },
});

export const UserRecordActions = createActionGroup({
    source: 'User Record',
    events: {
        'Set Users': props<{ records: Map<string, StorytellingUserRecord> }>(),
        'Update Users': props<{ records: StorytellingUserRecord[] }>(),
    },
});

export const DiscoverRecordActions = createActionGroup({
    source: 'Discover Item Record',
    events: {
        'Set Discover Items': props<{ records: Map<string, StorytellingRecord> }>(),
        'Update Discover Item': props<{ records: StorytellingRecord[] }>(),
    },
});

export const RecordHttpActions = createActionGroup({
    source: 'Record Http',
    events: {
        'Load Playbook Objects': props<{ vs?: ViewStateRecordsAlias }>(),
        'Load Rundown Objects': props<{ vs?: ViewStateRecordsAlias }>(),
        'Load Rundowns': props<{ vs?: ViewStateRecordsAlias }>(),
        'Load new Items': emptyProps(),
        'Move Record To Group': props<{ sourceGuid: string; targetGuid: string; sourceGroup: string; targetGroup: string }>(),
        'Save Record Changes': props<{ fieldsToUpdate: EnpsField[]; record: StorytellingRecord }>(),
        'Duplicate Topic': props<{ linkToParent: boolean; oldRecord: StorytellingTopicRecord; isNew: boolean }>(),
        'Duplicate Assignment': props<{ record: StorytellingAssignmentRecord; linkToParent: boolean }>(),
        'Delete Record': props<{ record: StorytellingRecord }>(),
        'Create Attachment': props<{ files: AttachmentFiles[]; record: StorytellingRecord }>(),
        'Should Proceed Attachment': props<{ recordAttachments: UploadFile[]; record: StorytellingRecord }>(),
        'Remove Attachment': props<{ attachment: AttachmentListItem; record: StorytellingRecord }>(),
        'Native Android Upload': props<{ nativeAndroidEvent: any; record: StorytellingRecord }>(),
        'Load User Locations': props<{ fq: string; locations: string[] }>(),
        'Open New Template Dialog': props<{ record: StorytellingTopicRecord | StorytellingAssignmentRecord | StorytellingStoryRecord }>(),
        'Load Single Item': props<{ guid: string }>(),
        'Delete record Template': props<{ guid: string; recordType: ObjectTypes }>(),
        // 'Load Records Success': props<{ data: any }>(),
        // 'Load Records Error': props<{ error: string }>(),
        // 'Save Record': props<{ topic: any }>(),
        // 'Save Record Success': props<{ topic: any }>(),
        // 'Save Record Error': props<{ error: string }(),
    },
});
